import { useMemo, useState } from "react";

import { Container, Row } from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import Loader from "../../Components/Common/Loader";
import TableContainer from "../../Components/Common/TableContainer";
import { useDeletePublicity, usePublicities } from "../../hooks/usePublicities";
import defaultPublicityImage from "../../assets/images/lcbtp.png";
import { getStoredAuthUser } from "../../utils/backendApi";

//Import actions

//redux
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import { red } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

const PriorityStars = ({ priority }) => {
  const renderStars = () => {
    if (priority && priority > 0 && priority <= 5) {
      const stars = [];
      for (let i = 1; i <= 5; i++) {
        stars.push(
          <span
            key={i}
            style={{
              color: i <= priority ? "#DC7621" : "#a3a3a3",
            }}
          >
            &#9733; {/* Étoile Unicode */}
          </span>
        );
      }
      return stars;
    } else {
      return null;
    }
  };

  return <div>{renderStars()}</div>;
};

const AdvertisementsPage = (props) => {
  const role = Boolean(
    (getStoredAuthUser()?.role ?? []).some((role) => role === "assistant")
  );

  const { data: publicites, isLoading, isError, error } = usePublicities();

  const deleteMutation = useDeletePublicity();

  const publicitesList = Array.isArray(publicites)
    ? publicites
    : publicites?.results || [];

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [selectedPublicity, setSelectedPublicity] = useState(null);

  const onClickDelete = (publicityItem) => {
    setSelectedPublicity(publicityItem);
    setDeleteModal(true);
  };

  const handleDeletePublicity = () => {
    if (selectedPublicity && selectedPublicity.id) {
      deleteMutation.mutate(selectedPublicity.id, {
        onSettled: () => setDeleteModal(false),
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((element) => {
      // dispatch(deleteProducts(element.value));
      del.style.display = "none";
    });
  };

  const columns = useMemo(
    () => [
      {
        Header: props.t("ILLUSTRATION"),
        Cell: (publicity) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <img
                  src={
                    publicity.row.original.publicity_pic ||
                    defaultPublicityImage
                  }
                  alt={props.t("Illustration")}
                  className="avatar-sm rounded"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = defaultPublicityImage;
                  }}
                />
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("TITRE"),
        accessor: "title",
        Cell: (publicity) => (
          <>
            <div
              className="d-flex align-items-center"
              style={{
                width: 200,
                height: 50,
                overflow: "clip",
                verticalAlign: "middle",
                textTransform: "uppercase",
              }}
            >
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  <Link className="text-dark">
                    {" "}
                    {publicity.row.original.title}
                  </Link>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("CONTENU"),
        accessor: "content",
        Cell: (publicity) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                {publicity.row.original.publicity_content ? (
                  <h5
                    className="fs-14 mb-1"
                    style={{
                      width: 200,
                      height: 50,
                      overflow: "clip",
                      verticalAlign: "middle",
                    }}
                  >
                    <Link
                      to={`/#/${publicity.row.original.id}/`}
                      className="text-dark"
                    ></Link>
                    {publicity.row.original.publicity_content}
                  </h5>
                ) : (
                  <h5 className="fs-14 mb-1">Pas de description</h5>
                )}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("PRIORITE"),
        accessor: "priority",
        Cell: (publicity) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                {publicity.row.original.priority && (
                  <PriorityStars priority={publicity.row.original.priority} />
                )}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("STATUT"),
        Cell: (publicity) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14  p-2">
                  <span className="mt-4">
                    {publicity.row.original.published === false && !role ? (
                      <div>
                        <div className="btn btn-soft-success">
                          <Link
                            to={`/advertisements-details/${publicity.row.original.id}/`}
                          >
                            Publier
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <h5
                        className="mb-1 badge badge-soft-success "
                        style={{ fontSize: "10px" }}
                      >
                        Publiée
                      </h5>
                    )}
                  </span>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "ACTIONS",
        Cell: (cellProps) => {
          const publicitiesData = cellProps.row.original;
          return (
            <div className="d-flex gap-2">
              <li className="list-inline-item" title={props.t("Modifier")}>
                <Link
                  to={`/advertisements-update/${publicitiesData.id}/`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </Link>
              </li>

              <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  to={`/advertisements-details/${publicitiesData.id}/`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li>

              <li className="list-inline-item" title={props.t("Supprimer")}>
                <Link
                  to="#"
                  className="text-danger d-inline-block"
                  onClick={() => onClickDelete(publicitiesData)}
                >
                  <i className="ri-delete-bin-5-line align-middle"></i>
                </Link>
              </li>
            </div>
          );
        },
      },
    ],
    [props, role]
  );

  document.title = props.t("Liste des publicités");

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return (
      <Loader error={error?.message || props.t("Erreur lors du chargement")} />
    );
  }

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeletePublicity}
        onCloseClick={() => setDeleteModal(false)}
        isPending={deleteMutation.isPending}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={props.t("Liste des publicités")}
          pageTitle={props.t("Liste des publicités")}
        />

        <Row>
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="card">
                <div className="card-body pt-0">
                  {publicitesList.length ? (
                    <div>
                      <TableContainer
                        columns={columns}
                        data={publicitesList || []}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={10}
                        divClass="table-responsive mb-1"
                        tableClass="mb-0 align-middle "
                        theadClass="table-light text-muted"
                        isPublicitiesFilter={true}
                      />
                    </div>
                  ) : (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{props.t("Désolé, pas de resultats trouvés")}</h5>
                      </div>
                      <div className="mt-4">
                        <Link
                          to="/advertisements-add"
                          className="btn btn-warning"
                        >
                          <i className="ri-add-line align-bottom me-1"></i>{" "}
                          {props.t("Ajouter une publicité")}
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

AdvertisementsPage.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(AdvertisementsPage));
